import { IS_AUTH_METHOD_COOKIE } from '@app/environment/typed-env';
import { AuthResDto, ConfirmPasswordReqDto, ForgotPasswordReqDto, SignInReqDto } from './auth.dto';
import { AuthType } from './auth.type';

import { apiService } from '@app/services/api-service';

export abstract class AuthApi {
  static async me() {
    return apiService.get<AuthResDto>('/private/auth/me');
  }

  static async signIn(dto: Omit<SignInReqDto, 'authType'>) {
    return apiService.post<AuthResDto, SignInReqDto>('/public/auth/sign-in/', {
      ...dto,
      authType: IS_AUTH_METHOD_COOKIE ? AuthType.COOKIE : AuthType.TOKEN,
    });
  }

  static async signOut() {
    return apiService.post<AuthResDto>('/private/auth/sign-out/');
  }

  static async forgotPassword(dto: ForgotPasswordReqDto) {
    return apiService.post('/public/auth/forgot-password/step-1', dto);
  }

  static async confirmPassword(dto: ConfirmPasswordReqDto) {
    return apiService.post('/public/auth/forgot-password/step-2', dto);
  }
}
